import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function LineReveal({ children, delay = 0, inView = false, className = "" }) {
  const inner = (
    <motion.span
      className="block will-change-transform"
      initial={{ y: "112%" }}
      {...(inView
        ? { whileInView: { y: 0 }, viewport: { once: true, amount: 0.6 } }
        : { animate: { y: 0 } })}
      transition={{ duration: 1.05, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  );
  return <span className={`mask-line ${className}`}>{inner}</span>;
}

export function ParallaxImage({ src, alt, className = "", intensity = 7, priority = false, position = "50% 50%" }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [`-${intensity}%`, `${intensity}%`]);
  return (
    <div ref={ref} className={`overflow-hidden ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        style={{ y, objectPosition: position }}
        className="w-full h-full object-cover scale-[1.16]"
        loading={priority ? "eager" : "lazy"}
      />
    </div>
  );
}

export function FadeIn({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}
